export enum CashierManagementStatusEnum {
    All = 0,
    Opened = 5,
    Closed = 10,
    Accounted = 15,
}
